import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const cblQueryKeys = {
  all: ['cbls'],
  lists: (id, params) => [...cblQueryKeys.all, 'list', id, params],
  list: (id, params) => [...cblQueryKeys.lists(id, params)],
  prediction: (id, params) => [...cblQueryKeys.all, 'prediction', id, params],
  live: (id, params) => [...cblQueryKeys.all, 'live', id, params],
};

// CBL 조회
export const useCbl = (id, algorName, params = {}) => {
  return useQuery({
    queryKey: cblQueryKeys.live(id, { algorName, ...params }),
    queryFn: async () => {
      try {
        const response = await api.post(`/drivecore/livecbl/api/LiveCblData/pack`,  params);
        return response || null;
      } catch (error) {
        console.error('CBL API Error:', error);
        return null;
      }
    },
    enabled: !!id,
    retry: 1,
    retryDelay: 1000,
  });
};

export const usePredictionCbl = ({ stationSysIdList, targetDate, cblModuleName, cblModuleVersion, enabled = true }) => {
  return useQuery({
    queryKey: cblQueryKeys.prediction(stationSysIdList, targetDate, cblModuleName, cblModuleVersion),
    queryFn: async () => {
      try {
        const response = await api.post(`/drivecore/predictioncbl/api/PredictionCblData/pack`, {
          stationSysIdList,
          targetDate,
          cblModuleName,
          cblModuleVersion
        });
        return response || null;
      } catch (error) {
        console.error('PredictionCbl API Error:', error);
        return null;
      }
    },
    enabled: enabled && !!stationSysIdList && !!targetDate && !!cblModuleName && !!cblModuleVersion,
    retry: 1,
    retryDelay: 1000,
  });
};
